import { defineComponent as o, createBlock as n, openBlock as r, unref as l, withCtx as s, createElementVNode as e, normalizeClass as p, renderSlot as m } from "vue";
import { Tab as u } from "@headlessui/vue";
const i = /* @__PURE__ */ o({
  __name: "ExampleResponseTab",
  setup(c) {
    return (t, d) => (r(), n(l(u), { as: "template" }, {
      default: s(({ selected: a }) => [
        e("button", {
          class: p(["tab", { "tab-selected": a }]),
          type: "button"
        }, [
          e("span", null, [
            m(t.$slots, "default", {}, void 0, !0)
          ])
        ], 2)
      ]),
      _: 3
    }));
  }
});
export {
  i as default
};
